module.exports = __webpack_public_path__ + "img/codeIcon.3c9cb773.png";